import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

export function useGetCertificate(employerNumber, staffNumber, enabled = false) {
  return useQuery({
    queryKey: ['certificate', employerNumber, staffNumber],
    queryFn: async () => {
      // Build URL manually to avoid URL-encoding of slashes
      // The backend expects actual '/' not '%2F' in both employer and staff numbers
      const baseUrl = '/pensions/get-certificate';
      // Don't encode employer_number to preserve slashes
      const employerParam = employerNumber ? `employer_number=${employerNumber}` : 'employer_number=';
      // Don't encode staff_number to preserve slashes
      const staffParam = `staff_number=${staffNumber || ''}`;
      const url = `${baseUrl}?${employerParam}&${staffParam}`;
      
      const response = await apiClient.get(url);
      return response.data;
    },
    enabled,
  });
}